/* Mi & My page behaviour: reveal-on-scroll, count-up stats, back to top. */
(function(){
  if (window.Shopify && Shopify.designMode) document.documentElement.classList.add('mm-design-mode');

  /* reveal */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.14 }) : null;
  function watchReveals(root){
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('in'); });
  }
  watchReveals();
  /* safety net: anything a missed intersection left hidden is shown after load */
  addEventListener('load', function(){
    setTimeout(function(){ document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }, 1500);
  });

  /* count-up stats: <h3 class="count" data-count="300" data-suffix="K+"> */
  var cIo = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var el = e.target, target = parseInt(el.dataset.count, 10), suffix = el.dataset.suffix || '';
      var cur = 0, step = Math.max(1, Math.round(target/40));
      (function tick(){
        cur += step;
        if(cur >= target){ el.textContent = target + suffix; }
        else { el.textContent = cur + suffix; requestAnimationFrame(tick); }
      })();
      cIo.unobserve(el);
    });
  }, { threshold: 0.5 }) : null;
  function watchCounts(root){ (root || document).querySelectorAll('.count[data-count]').forEach(function(el){ cIo && cIo.observe(el); }); }
  watchCounts();

  /* back to top: appears after one screen of scroll */
  var b = document.getElementById('toTop');
  if(b){
    var chk = function(){ b.classList.toggle('on', window.scrollY > window.innerHeight); };
    addEventListener('scroll', chk, {passive:true}); chk();
    b.addEventListener('click', function(){ window.scrollTo({top:0, behavior:'smooth'}); });
  }

  /* Swipe rows always open on the first card.
     Lazy images finish loading after paint, the row gets wider, and
     scroll-snap:mandatory re-snaps - which can leave it parked on card three.
     Hold every row at the start until the reader actually swipes it. */
  (function(){
    var SEL = '.catalog, .routine-row, .days-track, .quote-strip, .ugc-row, .vid-row,'
            + '.blog-grid, .why-grid, .mini-reviews, .replay-grid, .val-grid, .pgrid,'
            + '.bene, .tl, .steps, .cross';
    function rows(root){
      return Array.prototype.filter.call((root||document).querySelectorAll(SEL), function(r){
        return r.scrollWidth > r.clientWidth + 4;
      });
    }
    function pin(root){
      rows(root).forEach(function(r){
        if(r.dataset.mmTouched) return;
        if(r.scrollLeft !== 0) r.scrollLeft = 0;
        if(!r.dataset.mmPinned){
          r.dataset.mmPinned = '1';
          ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){
            r.addEventListener(ev, function(){ r.dataset.mmTouched = '1'; }, { passive:true, once:true });
          });
        }
      });
    }
    pin();
    document.addEventListener('DOMContentLoaded', function(){ pin(); });
    window.addEventListener('load', function(){ pin(); setTimeout(pin, 300); setTimeout(pin, 1200); });
    document.addEventListener('shopify:section:load', function(e){ pin(e.target); });
  })();

  /* theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function(e){ watchReveals(e.target); watchCounts(e.target); });
})();
